@charset "UTF-8";

/* src/app/module/users/user-details/user-details.component.scss */
body {
  margin-left: 250px;
  overflow-y: auto;
}
.top-content {
  gap: 16px;
}
.tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}
.tag.submitted {
  background-color: #FFF1E0;
  color: #D47500;
  justify-content: space-around;
}
.tag.submitted::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 2px;
  border-radius: 50%;
  background-color: #D47500;
}
.tag.inreview {
  background-color: #FFF1E0;
  color: #D47500;
  justify-content: space-around;
}
.tag.inreview::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 4px;
  border-radius: 50%;
  background-color: #D47500;
}
.tag.approved {
  background-color: #ECFDF3;
  color: #027A48;
  justify-content: space-around;
}
.tag.approved::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background-color: #4caf50;
}
.tag.inactive {
  background-color: #f4f4f4;
  color: #757575;
  justify-content: space-around;
}
.tag.inactive::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background-color: #757575;
}
.tag.rejected {
  background-color: #FFEAEB;
  color: #FF474D;
  justify-content: space-around;
}
.tag.rejected::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background-color: #FF474D;
}
.top-container {
  display: flex;
  padding: 18px 0px 24px 0px;
  flex-direction: column;
  border-radius: 0px 0px 24px 24px;
  background: var(--Gray-100, #F2F4F7);
}
.custom-button {
  background-color: #FF8C00;
  border: #FF8C00;
}
.btn-1 {
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  border-radius: 8px;
  padding: 8px 16px;
  cursor: pointer;
  transition:
    background-color 0.3s,
    color 0.3s,
    border-color 0.3s;
  height: 40px;
}
.btn-2 {
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  border-radius: 8px;
  padding: 8px 16px;
  cursor: pointer;
  transition:
    background-color 0.3s,
    color 0.3s,
    border-color 0.3s;
  height: 40px;
}
.btn-warning-1 {
  background-color: white;
  color: #B42318;
  border: 1px solid #B42318;
}
.btn-contrast-1 {
  background-color: #fff;
  color: #000;
  border: 1px solid #D0D5DD;
}
.outlined-1 {
  background-color: #fff;
  color: #B42318;
  border-color: #B42318;
}
.outlined {
  background-color: transparent;
  color: #333;
  border-color: #333;
}
.small-1 {
  font-size: 14px;
  padding: 4px 8px;
}
.btn-1:hover,
.btn-2:hover,
.btn-mark-disable:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
.btn-1:focus {
  outline: none;
  box-shadow: none;
}
.btn-2:focus {
  outline: none;
  box-shadow: none;
}
.review-heading {
  font-size: 20px;
  color: #000;
  font-weight: 600;
}
.card-top {
  border-radius: 10px;
  background: white;
  margin-left: 12px;
  margin-right: 12px;
  display: flex;
  justify-content: space-between;
  padding: 20px;
}
.image {
  width: 370px;
  height: 280px;
  flex: 1 1 0;
}
.text {
  width: 65px;
  flex: 2 1 0;
}
.main-text {
  text-align: start;
  font-size: 24px;
  font-weight: 600;
  line-height: 28px;
  width: 385px;
}
.secondary-text {
  font-size: 14px;
  font-weight: 500;
  color: var(--Gray-500, #667085);
}
.business-details {
  width: 234px;
  height: 75px;
  border-right: 1px solid #F2F4F7;
}
.owner {
  font-size: 14px;
  font-weight: 400;
  color: #475467;
}
.user-info {
  display: flex;
  align-items: self-start;
  margin-top: 16px;
}
.username {
  font-size: 16px;
  font-weight: 500;
  color: #101828;
}
.name {
  margin: 0;
}
.email {
  margin: 0;
  line-height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #475467;
}
.icon-circle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: #F2F4F7;
  overflow: hidden;
}
.card-content {
  display: flex;
}
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #ffecd9;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  color: #ff8c00;
  margin-right: 15px;
}
.info {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  margin-top: 8px;
}
.name-status {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}
.name {
  font-size: 20px;
  font-weight: 600;
  color: #333;
}
.status {
  font-size: 14px;
  color: #027A48;
  background-color: #ECFDF3;
  height: 20px;
  padding: 10px;
  align-items: center;
  display: flex;
  border-radius: 16px;
}
.status-rejected {
  color: #B42318;
  background-color: #F8D7DA;
}
.status-dot {
  width: 8px;
  height: 8px;
  background-color: #4caf50;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
}
.dot-rejected {
  background-color: red;
}
.details {
  display: flex;
}
.detail {
  flex: 1;
}
.detail-title {
  font-size: 14px;
  color: #344054;
  margin-bottom: 5px;
  font-weight: bolder;
}
.detail-content {
  font-size: 16px;
  color: #333;
}
.detail:last-child {
  margin-right: 0;
  margin-left: 10rem;
}
.badge {
  background-color: #EEF4FF;
  color: white;
  padding: 1.5px;
  border-radius: 12px;
  height: 22px;
}
.outlined-2 {
  background-color: transparent;
  color: #374151;
  border-color: #374151;
}
.row-container {
  display: flex;
  align-items: flex-start;
  margin-top: 10px;
  margin-bottom: 35px;
}
.divider {
  width: 1px;
  background-color: #667085;
}
.business-type-label {
  color: #475467;
  font-size: 14px;
  margin: 0;
  font-weight: 400;
}
.business-type-value {
  font-size: 16px;
  color: #101828;
  font-weight: 500;
  margin: 0;
  margin-top: 4px;
}
.service-container div {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.service-column {
  display: flex;
  flex-direction: column;
}
.service-item {
  margin: 5px;
}
.service-name {
  font-size: 14px;
  font-weight: 400;
  color: #475467;
  line-height: 24px;
}
.icon-circle-1 {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 18px;
  height: 18px;
  background-color: #D1FADF;
  border-radius: 50%;
  color: white;
  margin-right: 8px;
}
.employee-value {
  font-size: 24px;
  color: #101828;
  font-weight: 500;
  margin: 0;
  margin-top: 4px;
  margin-bottom: 40px;
}
::ng-deep .p-dialog-mask {
  background-color: rgba(8, 12, 20, 0.7);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
}
.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
}
.tyre-position {
  font-weight: 600;
  font-size: 16px;
  color: #98A2B3;
}
.dropdown {
  position: relative;
  display: inline-block;
}
.dropdown-button {
  background-color: #101828;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  margin-top: 16px;
  position: fixed;
  right: 20px;
  width: 125px;
  top: 532px;
}
.dropdown-button::after {
  content: "\25bc";
  margin-left: 10px;
  font-size: 12px;
}
.dropdown-content {
  position: fixed;
  right: 20px;
  top: 280px;
  border-radius: 8px;
  box-shadow: 0 4px 8px #101828;
  width: 240px;
}
.dropdown-content a {
  color: #101828;
  text-decoration: none;
  cursor: pointer;
}
.dropdown-content a:hover {
  background-color: #f0f0f0;
}
.dropdown {
  position: relative;
  display: inline-block;
  margin-bottom: 20px;
}
.dropdown-button {
  display: flex;
  align-items: center;
  justify-content: center;
}
.dropdown-button::after {
  content: "\25bc";
  margin-left: 10px;
}
.dropdown-content {
  background-color: #f9f9f9;
  min-width: 200px;
  z-index: 1;
  overflow: hidden;
}
.dropdown-content a {
  padding: 10px 25px;
  display: block;
}
.dropdown-content a:hover {
  background-color: #f1f1f1;
}
.dropdown-content a:last-child {
  border-bottom: none;
}
.main-part {
  padding-top: 32px;
  padding-left: 25px;
  border-bottom: 1px solid #f1f1f1;
}
.main-part[ng-animating=true] {
  transform: scale(0.9);
  opacity: 0;
}
::ng-deep .p-timeline .p-timeline-event-marker {
  border: 2px solid orange;
  background:
    linear-gradient(
      135deg,
      #FFD700,
      #FFA500);
}
.p-text-secondary strong {
  color: #000;
  font-size: 15px;
  margin-bottom: 10px;
}
/*# sourceMappingURL=user-details.component-S6E2BKXZ.css.map */
